import './App.css';

// React Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';

// React Router DOM
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// Pages
import PageHome from './Pages/Home';

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<PageHome />} />
            </Routes>
        </Router>
    );
}

export default App;
